import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles(theme => ({
    divider: {
        minHeight: '250px'
    },
    marginTop: {
        marginTop: theme.spacing(3)
    },
    marginBottom: {
        marginBottom: theme.spacing(3)
    }
}));

export default function ClubRegistrationForm (props) {

    const classes = useStyles();

    return (
        <div className="clubRegistrationForm">
            <Typography gutterBottom variant="subtitle1" align="center" color="textPrimary">
                Find an organization you already belong to or create your own.
            </Typography>
            <div className={classes.marginTop}/>
            <Grid container justify="space-between" alignItems="center" spacing={3} className={classes.marginBottom}>
                <Grid item xs={12} lg={6}>
                    <Typography variant="body2" align="center" color="textSecondary" component="div">
                        Search our publicly available organizations and request access. We will email you once an administrator has verified your membership or guest association.<br/>
                        <Button
                            className={classes.marginTop}
                            component={RouterLink}
                            variant="contained"
                            color="secondary"
                            to='/register/club/find'
                            >
                            Find an Organization
                        </Button>
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Typography variant="body2" align="center" color="textSecondary" component="div">
                        Create a new organization in a few easy steps. Get ready to sit back and relax with our feature rich platform and simplified member management tools.<br/>
                        <Button
                            className={classes.marginTop}
                            variant="contained"
                            color="secondary"
                            to='/register/club/new'
                            component={RouterLink}
                            >
                            Create an Organization
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
}
